<template>
    <div class="index-branch-list">
        <BranchItem v-for="(branch, index) in (item.itemList||item.contentList)" :key="index" v-bind="$attrs"  :row="index" :branch="branch" :goodsList="goodsList[branch.branchId||branch.refId] && goodsList[branch.branchId||branch.refId].data || []" :item="item" v-track:exposure :track-params="JSON.stringify(item)"/>
    </div>
</template>

<script>
import http from "@/utils/axios";
import BranchItem from './branchItem';
export default {
    props: {
        item: {
            type: Object,
            default: function() {
                return {}
            }
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            goodsList: {}
        }
    },
    created() {
        this.getBranchRecommend()
    },
    methods: {
        getBranchRecommend() {
            let itemlist = this.item.itemList||this.item.contentList
            let idList = itemlist.map(e => e.branchId || e.refId);
            let topDatas = []
            
            itemlist.forEach(item=>{
                let list = item.mixTopList.map(it=>{
                    return {
                        extraScore: it.sort,
                        id: it.idValue,
                        type: it.idType == 1? 'DISCOVER' : 'PRODUCT'
                    }
                })
                topDatas.push(...list)
            })
            let parmes = {
                isMarkingPrice: 'y', 
                isPrice: 'y',
                pageSize: 10,
                topDatas
            }
            if(this.item.type == 4) {
                parmes.branchIds = idList;
                parmes.floorType = 'BYBRANCH';
            } else {
                parmes.logoIds = idList
                parmes.floorType = 'BYLOGO';
            }
            http({
                url: '/search/es/mixed/datasource/batch',
                method: 'post',
                parmes
            }).then(rps=>{
                if(rps.code == 200) {
                    this.$loading.hide()
                    this.goodsList = rps.data
                }
            })
        }
    },
    components: {
        BranchItem
    },
    // watch: {
    //     isLoading: function(val) {
    //         if(val) {
    //             setTimeout(()=>{
    //                 this.getBranchRecommend()
    //             }, 1500)
    //         }
    //     }
    // }
}
</script>
<style lang="less" scoped>
.index-branch-list {
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;
}
</style>